import { useCallback, useEffect, useState, useRef } from "react";
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import QRCode from 'react-qr-code';


import * as Api from "logic/api";
import { applicationContinue, applicationCheckResultCreate, applicationCheckResult, applicationCheckResultNoInit } from "logic/actions/api/application";
import { challengeCreate } from "logic/actions/api/liveness";
import { typeDecryptParams, queryParams, getPathname } from "logic/typeDecryptParams";
import { generateUserID } from 'logic/userId';
import { setConfiguration } from "logic/actions/configuration";
import { sessionExpire } from 'logic/encryptData';
import { setApplicationParams } from "logic/actions/application";
import { setCheckResultCode } from "logic/actions/checkResult";
import { logEvent } from "logic/eventLogger";
import {
  USER,
  IFRAME
} from 'logic/actions/application';

import { 
  checkCameraAccess, 
  checkCameraSupport, 
  defaultHandleFailure, 
  setDefaultCameras, 
  recommendBrowser 
} from "logic/cameraChecker";

import ProcessingOverlay from 'logic/loading'
import PageExpireLink from 'Components/myModules/PageExpireLink';
import CommonModal from '../CommonModal'
import Button from '../Button'
import PageVerifyIdentity from '../PageVerifyIdentity'
import ThankYou from "../ThankYou";
import Header from '../Header';
import PageResult from '../PageResult';
import PageWrapper from '../PageWrapper';


import './style.css'

import idCardFront from '../../../assets/icons/figma/id-card-front.svg'
import selfieFace from '../../../assets/icons/figma/selfie-face.svg'
import errorIcon from '../../../assets/icons/figma/error.svg'


const StepCard = ({ img, children }) => {
  return (
    <div className="step-card">
      <div className="step-img-box">
        <img src={img} alt="step" className="step-img" />
      </div>

      <div className="step-content">
        {children}
      </div>
    </div>
  );
};

// eslint-disable-next-line
const PATH_NAME_MAP = ['iframe'];

// MAX_DURATION means the maximum duration waiting for check result, unit is minutes
const MAX_DURATION = 5 // 5 min

export default function Main() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const pathname = getPathname()
  const parameters = queryParams()
  const flag = parameters.get('flag')?.toLocaleUpperCase()
  const start = parameters.get("start")
  const result = typeDecryptParams(flag, start)

  const [error, setError] = useState("");
  // const [loading, setLoading] = useState(true)
  const [showQrCode, setShowQrCode] = useState(false)
  const [currentPage, setCurrentPage] = useState("");
  const [expireStatus, setExpireStatus] = useState(false);
  const [configError, setConfigError] = useState(false);
  const [configurationDone, setConfigurationDone] = useState(false)
  const [isParams, setIsParams] = useState({
    userOfUse: USER,
    pathname: pathname,
    componentID: result.componentID,
    referenceID: result.referenceID,
    nationality: result.nationality?.trim().toLowerCase() || "undefined",
    createDate: result.createDate,
    urlStart: window.location.href,
    showValid: result.show ? result.show.toLowerCase().split(',') : "undefined",
    insureAge : result.insureAge?.trim() || 'undefined',
    risk: result.risk?.trim().toLowerCase() || 'medium',
    salesChannel: result.salesChannel?.toLowerCase() || 'non-f2f',
    occupation: result.occupation?.trim() || 'undefined',
    allowRetryOtherDoc: result.allowRetryOtherDoc?.trim().toLowerCase() || 'y',
    hideSuccessPage: result.hideSuccessPage?.trim().toLowerCase() || 'undefined',
    callbackURL: result.callbackURL ?? 'undefined',
    requiredField: {
      idCard: result.idCard?.trim() || 'undefined',
      firstName: result.firstName?.trim() || 'undefined',
      lastName: result.lastName?.trim() || 'undefined',
      dateOfBirth: result.dateOfBirth?.trim() || 'undefined',
      gender: result.gender?.trim() || 'undefined',
    }
  });
  const [pending, setPending] = useState(true);
  const [pendingQr, setPendingQr] = useState(true);
  //================
  const [disabled, setDisabled] = useState(false)

  const [modal, setModal] = useState({
    show: false,
    type: null,
  });

  const paramsRef = useRef(isParams)
  const startTimeRef = useRef(0);
  const delayRef = useRef(10000);
  const stoppedRef = useRef(false);

  const timerRef = useRef(null);

  const modalMap = {
    pollingDeadLine: {
      icon: errorIcon,
      title: "รีเฟรชหน้านี้เพื่ออัปเดตข้อมูล",
      desc: "หากยืนยันตัวตนด้วยอุปกรณ์อื่น เรียบร้อยแล้ว กรุณารีเฟรชหน้านี้ เพื่อดำเนินการต่อ",
      confirmText: "รีเฟรช",
    },
    cameraPermissonDeny: {
      icon: errorIcon,
      desc: "การอนุญาตเข้าถึงกล้องปิดอยู่ กรุณาอนุญาตให้เข้าถึงกล้องและลองใหม่อีกครั้ง",
      confirmText: "ลองใหม่อีกครั้ง",
    }
  }

  const config = modalMap[modal.type] || {};
  
  const openModal = (type) => {
		setModal({
			show: true,
			type
		});
	};

  const redirectToCaller = useCallback(() => {
    setCurrentPage('THANK_YOU')
  }, [])


  const updateParams = (updater) => {
    const newParams = typeof updater === 'function'
      ? updater(paramsRef.current)
      : updater

    paramsRef.current = newParams

    setIsParams(newParams)

    return newParams
  }

  
  const completeEkyc = (data) => {
    const { code, ruleResult } = data
    return code === "0" && (ruleResult === "0" || ruleResult === "1")
  }

  const submit = (e) => {
    e.preventDefault()
    
    stoppedRef.current = true;
    clearTimeout(timerRef.current);

    setPending(true);
    handleSuccessAplication()
  }

  const handleSuccessAplication = () => {
    logEvent("landing_page", {
      start_time: window.performance.now(),
      response: null
    })

    dispatch(challengeCreate())
      .then((res) => {
        logEvent("landing_page", {
          reponse: res
        })
        setCurrentPage('SELECT')
      })
      .catch((err) => {
        logEvent("landing_page", {
          reponse: err
        })
        setError(err.toString())
        setPending(false)
      });
  };

  const poll = async () => {
    if (stoppedRef.current) return;
    applicationCheckResultNoInit()(dispatch)
      .then((res) => {
        logEvent(`Application_config-Check-Result[${pathname}]`, {
          pathname: pathname,
          response: res
        })

        if (completeEkyc(res.data)) {
          stoppedRef.current = true;
          console.log("✅ complete ekyc, stop Polling");
          setPending(false)
          redirectToCaller()
          return
        }

        const duration = Date.now() - startTimeRef.current;
        if (duration >= MAX_DURATION * 60 * 1000) {
          stoppedRef.current = true;
          console.log("⏰ time is over, stop Polling");
          openModal('pollingDeadLine')
          return;
        }

        delayRef.current += 10000;
        setTimeout(poll, delayRef.current);

      })
      .catch((error) => {
        console.error("polling failed:", error);
        stoppedRef.current = true;
      })
  };

  const showQrcodeFn = (param) => {
    if(param.componentID === '90' || param.componentID === '91') {
      if(param.secondDevice !== 'yes') {
        setShowQrCode(true)
      }
    }
  }

  const handleOnHide = () => {
    setModal({show: false})
  }

  const allowCamera = () => {
    if (!checkCameraSupport()) {
      setPending(false)
      openModal('cameraPermissonDeny')
    }
    checkCameraAccess().then(() => {
      setDefaultCameras();
    }, (err) => {
      setPending(false)
      openModal('cameraPermissonDeny')
    });
  }

  const restartApp = () => {
    setModal({show: false})
    window.location.reload();
  }

  useEffect(() => {

    let currentPathname = PATH_NAME_MAP.includes(pathname)
    console.log(pathname, currentPathname);
    setApplicationParams(isParams)(dispatch)
    if (
      !currentPathname ||
      !start ||
      !result.componentID ||
      !result.referenceID ||
      !result.callbackURL
    ) {
      setError('This URL is invalid.')
    }

  // eslint-disable-next-line
  }, [])

  useEffect(() => {
    Api.getConfiguration()
      .then((response) => {
        if (
          process.env.NODE_ENV === "development" &&
          response.data.documentQualityHostname.includes("sampleapp")
        ) {
          const externalDocumentQualityURL = new URL(
            response.data.documentQualityHostname
          );
          const externalFaceQualityURL = new URL(
            response.data.faceQualityHostname
          );

          externalDocumentQualityURL.hostname = `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}`;
          externalFaceQualityURL.hostname = `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}`;

          response.data.faceQualityHostname = externalFaceQualityURL.href;
          response.data.documentQualityHostname =
            externalDocumentQualityURL.href;
        }
        dispatch(setConfiguration(response.data));
        setConfigurationDone(true)
      })
      .catch(() => {
        setPending(false)
        setConfigError(true);
        setError(t("ApplicationConfig.error_connection"));
      });
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!configurationDone || configError) return;

    const userInfo = {
      userId: generateUserID(result.componentID, result.referenceID)
    }
    const tempUrl = window.location.href.split('=')[0];
    if (result.createDate) {
      if (sessionExpire(result.createDate, result.componentID)) {
        setCurrentPage('EXPIRE_LINK')
        setExpireStatus(true)
      }
    }

    const _urlStart = tempUrl + "=" + result.newEncryptURL
    
    const newParams = updateParams(prev => ({
      ...prev,
      userOfUse: IFRAME,
      urlStart: _urlStart,
      secondDevice: result.second ?? "undefined",
    }))

    if (!expireStatus) {
      showQrcodeFn(newParams)
      allowCamera()
      applicationCheckResultCreate(userInfo)(dispatch)
        .then((res) => {
          logEvent(`Application_config-Check-Result[${pathname}]`, {
            pathname: pathname,
            response: res
          })
          setApplicationParams(newParams)(dispatch);

          dispatch(
            setCheckResultCode({
              code: res.data.code,
              ruleResult: res.data.ruleResult,
            })
          );

          if (completeEkyc(res.data)) {
            setPending(false)
            setCurrentPage('THANK_YOU')
            return
          } 
          applicationContinue({ applicationId: userInfo.userId })(dispatch)
            .then((res) => {
              
              logEvent(`Application_config-Continue[${pathname}]`, {
                pathname: pathname,
                response: res,
                params: newParams
              })
              setPending(false)
              setPendingQr(false)
              setDisabled(false)
              
            })
            .catch((err) => {
              logEvent(`Application_config-Continue[${pathname}]`, {
                pathname: pathname,
                response: err
              })
              setError(err.toString())
              setPendingQr(false)
              setPending(false)
            })
        })
        .catch((err) => {
          logEvent(`Application_config-Check-Result[${pathname}]`, {
            pathname: pathname,
            response: err
          })
          applicationContinue({ applicationId: userInfo.userId })(dispatch)
            .then((res) => {

              setApplicationParams(newParams)(dispatch)
              setPending(false)
              setPendingQr(false)
              setDisabled(false)
              logEvent(`Application_config-Continue[${pathname}]`, {
                pathname: pathname,
                response: res,
                params: newParams
              })
            })
            .catch((err) => {
              logEvent(`Application_config-Continue[${pathname}]`, {
                pathname: pathname,
                response: err
              })
              setPending(false)
              setPendingQr(false)
              setError(err.toString())
            })
        })
    }
  // eslint-disable-next-line
  }, [configurationDone, configError])

  useEffect(() => {

    if (pendingQr) return;

    console.log("start polling");

    startTimeRef.current = Date.now();

    timerRef.current = setTimeout(poll, delayRef.current);

    return () => {
      stoppedRef.current = true;
      clearTimeout(timerRef.current);
    };
  }, [pendingQr]);

  if(error) {
    return (
      <PageResult 
        header='ยืนยันตัวตน e-KYC'
        icon={errorIcon}
        titleText='ไม่สามารถดำเนินการต่อได้'
        des='กรุณาลองใหม่อีกครั้ง'
        buttonText='ลองใหม่อีกครั้ง'
        onClick={restartApp}
      />
    )
  }

  if (currentPage === 'SELECT') {
    return <PageVerifyIdentity />
  }

  if (currentPage === 'EXPIRE_LINK') {
    return <PageExpireLink />
  }

  if (currentPage === 'THANK_YOU') {
    return <ThankYou />
  }
  

  return (
    <PageWrapper>
      <ProcessingOverlay 
        pending={pending}
        global
      />


        <Header text='ยืนยันตัวตน e-KYC'/>

        <Container
          className="app-container"
        >
        
          <h6 className="app-instruction-title-h6">เตรียมตัวเพื่อยืนยันตัวตนทางอิเล็กทรอนิกส์</h6>

          <div className="steps">
            
            <div className="step-item">
              <div className="step-title">
                1. รูปถ่ายบัตรประชาชนตัวจริงด้านหน้า
              </div>

              <StepCard img={idCardFront}>
                <ul>
                  <li className="idCardFront-li1">วางบัตรให้อยู่ในกรอบที่กำหนดเห็นข้อมูลและใบหน้าชัดเจน</li>
                  <li>ไม่มีแสงสะท้อนบนบัตร</li>
                  <li>วางบัตรบนพื้นสีทึบ</li>
                </ul>
              </StepCard>
            </div>

            <div className="step-item">
              <div className="step-title">
                2. รูปถ่ายเซลฟี่เห็นใบหน้า
              </div>

              <StepCard img={selfieFace}>
                <ul>
                  <li>ถ่ายภาพหน้าตรงในกรอบที่กำหนด ถอดหมวก แว่นตา และผ้าปิดปาก</li>
                  <li>มีแสงสว่างเพียงพอ ไม่มีแสงสะท้อน โดยเฉพาะบริเวณดวงตา</li>
                </ul>
              </StepCard>
            </div>

          </div>

          {showQrCode && 
            <div className="qr">
              <div className="qr-text">
                <div className="qr-title">
                  ยืนยันตัวตนด้วยอุปกรณ์อื่น
                </div>

                <div className="qr-desc">
                  หากต้องการใช้อุปกรณ์อื่นเพื่อถ่ายบัตรประชาชนและเซลฟี่สแกน QR code ได้ที่นี่
                </div>
              </div>

              
              <div className="qr-code">
                <ProcessingOverlay 
                  pending={pendingQr}
                  text=''
                >
                  <QRCode 
                    value={showQrCode ? isParams.urlStart : "placeholder"}
                    size={110} 
                    fgColor={showQrCode ? "#000" : "#ccc"}
                  />
                  
                </ProcessingOverlay>

              </div>
            </div>
          }
          
          <div className="app-footer">
            <Button 
              // disabled={disabled || error}
              disabled={error}
              onClick={submit}
            >
              เริ่มยืนยันตัวตน
            </Button>
          </div>

          <CommonModal
            show={modal.show}
            title={config.title}
            confirmText={config.confirmText}
            icon={config.icon}
            desc={config.desc}
            onConfirm={restartApp}
            onHide = {handleOnHide}
          />

        </Container>
    </PageWrapper>
  )
}


